import Vue from 'vue'

const createLoadingBox = (el) => {
    let position = window.getComputedStyle(el).position

    if (position === 'static' || position === '') {
        el.dataset.static = true
        el.style.position = 'relative'
    }

    let box = document.createElement('div')
    box.className = 'loading_box'
    el.appendChild(box)

    let div = document.createElement('div')
    box.appendChild(div)
}

const handleShow = (el) => {
    if (el.querySelector('.loading_box') === null)
        createLoadingBox(el)

    let box = el.querySelector('.loading_box')

    window.requestAnimationFrame(() => {
        box.style.opacity = 1
    })

    el.dataset.blocked = true
    el.setAttribute('disabled', 'disabled')
}

const handleHide = (el) => {
    let box = el.querySelector('.loading_box')

    box.addEventListener('transitionend', () => {
        box.remove()

        if (el.dataset.static)
            el.style.removeProperty('position')
    })

    box.style.opacity = 0.01

    el.dataset.blocked = false
    el.removeAttribute('disabled')
}

Vue.directive('pml-block', {
    bind (el, binding) {
        el.dataset.static = false
        el.dataset.blocked = false
    },
    update (el, binding) {
        let isVisible = el.querySelector('.loading_box') !== null && el.querySelector('.loading_box').offsetLeft >= 0

        if ((binding.value && isVisible) || (!binding.value && !isVisible))
            return null
        else
            binding.value ? handleShow(el) : handleHide(el)
    }
})



// WEBPACK FOOTER //
// ./src/utils/directives/block.js